import { AuthConstants } from 'constants/auth';
import { refreshToken } from './aws';

export const refreshTokenMiddleware = () => (next) => async (action) => {
  if (action.type !== AuthConstants.AUTH_SIGN_OUT && sessionStorage.getItem('expiryTime') !== null) {
    const expiryTime = sessionStorage.getItem('expiryTime');

    if (expiryTime < Date.now()) {
      const delta = Date.now() - expiryTime;
      if (delta > 3600 * 1000) { // Web browser had been closed
        return next({ type: AuthConstants.AUTH_SIGN_OUT });
      }
      if (sessionStorage.getItem('isTokenRefreshing') === 'true') {
        const timer = setInterval(() => {
          if (sessionStorage.getItem('isTokenRefreshing') === 'false') {
            clearInterval(timer);
            return next(action);
          }
        }, 1000);
      } else {
        sessionStorage.setItem('isTokenRefreshing', 'true');
        await refreshToken()
          .then(() => next(action))
          .catch((err) => {
            console.log('refreshToken failed, redirecting', err, action);
            return next({ type: AuthConstants.AUTH_SIGN_OUT });
          });
      }
    } else {
      return next(action);
    }
  } else {
    return next(action);
  }
};
